import * as React from "react";
import { Badge } from "@/core/components/ui/badge";
import { Typography } from "@/core/components/ui/typography";
import { cn } from "@/core/utils/utils";

interface AutomationBadgeProps {
  className?: string;
}

export const AutomationBadge: React.FC<AutomationBadgeProps> = ({
  className,
}) => (
  <Badge variant="gray" className={cn("gap-2", className)}>
    <Typography variant="captionW1">Automation</Typography>
  </Badge>
);

AutomationBadge.displayName = "AutomationBadge";
